import { render, staticRenderFns } from "./shopMoney.vue?vue&type=template&id=fe32788e&"
import script from "./shopMoney.vue?vue&type=script&lang=js&"
export * from "./shopMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports